export default "__VITE_ASSET__89eb1d80__"